import { connect } from 'react-redux';
import DashboardPage from './DashboardPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { push } from 'react-router-redux';

// import { getCompleteOrderData } from 'src/actions/completeOrderAction';
import { tutorialVideo } from 'src/actions/dashboardAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { STORE_REDIRECT_FROM_DESIGNREADY } from 'src/reducers/completeorderfile';

export const mapStateToProps = (state: AppState) => {
    return {
        userDetails: state.user.userDetails,
        liveOrderCount: state.UserOrderData.total,
        completedOrderCount: state.UserOrderData.completed,
        onholdcount: state.UserOrderData.onhold,
        onreturn: state.UserOrderData.returned,
        designready: state.UserOrderData.designready,
        chartData: state.UserOrderData.items,
        greatestvalue: state.UserOrderData.greatest,
        completedcnt: state.UserOrderData.completedcnt,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        addNewOrder: () => {
            // dispatch(fetchCurrentUser);
            dispatch(push('/app/filestable'));
        },
        addNewFeedback: () => {
            dispatch(push('/app/feedback'));
        },
        liveOrder: () => {
            dispatch(push('/app/liveOrder'));
        },
        completedOrder: () => {
            dispatch(push('/app/completeOrders'));
            dispatch({ type: STORE_REDIRECT_FROM_DESIGNREADY, redirectDesignReady: false });
        },
        manuCompletedOrder: () => {
            dispatch(push('/app/manuCompleteOrders'));
            dispatch({ type: STORE_REDIRECT_FROM_DESIGNREADY, redirectDesignReady: false });
        },
        filterCompletedOrder: () => {
            dispatch(push('/app/completeOrders'));
            dispatch({ type: STORE_REDIRECT_FROM_DESIGNREADY, redirectDesignReady: true });
        },
        goTutorial: () => {
            dispatch(tutorialVideo);
        },
        onComponentDidMount: () => {
            // dispatch(getLiveOrderData);
            // dispatch(getChart);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
        }
    };
};

const DashboardPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DashboardPage);

export default DashboardPageContainer;



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardPageContainer.tsx